module.exports = __webpack_public_path__ + "static/media/userSelected.bbe675ea.svg";